import React from "react";
import { useNavigate,useLocation  } from "react-router-dom";
import "../styles/PasswordChangeConfirmation.css";
import successImage from "../assets/success.png"; // Mets ici ton image (celle que tu as partagée renommée)

export default function PasswordChangeConfirmation() {
  const navigate = useNavigate();
 const location = useLocation();

  const handleLoginRedirect = () => {
    navigate("/"); // Redirige vers la page de connexion
  };
    // Vérifie si l'URL se termine par "password/success"
  const hideMenu = location.pathname.endsWith("password/success");

  return (
    <div className="confirmation-container">
      {!hideMenu && (
      <div className="confirmation-sidebar">
        <h3>Paramètre</h3>
        <div className="confirmation-menu">
          <div className="active-tab">Mot de passe</div>
          <div className="inactive-tab">Utilisateur interne</div>
        </div>
      </div>
    )}


      <div className="confirmation-content">
        <img src={successImage} alt="Succès" className="confirmation-image" />
        <h1 className="confirmation-title">
          <span className="blue">Waa</span><span className="black">Go</span>
        </h1>
        <h2 className="confirmation-subtitle">
          C’est bon, votre mot de passe est tout neuf !
        </h2>
        <p className="confirmation-description">
          Vous pouvez maintenant vous connecter avec vos nouvelles informations.
          À bientôt sur votre espace !
        </p>
        <button className="confirmation-button" onClick={handleLoginRedirect}>
          Se connecter
        </button>
      </div>
    </div>
  );
}